module.exports = __webpack_public_path__ + "img/act_to_adapt@2x.64d6165a.png";